(() => {
  if (window.__adawatCardGalleryBound) return;
  window.__adawatCardGalleryBound = true;

  const bindGallery = (slides) => {
    if (!slides || slides.dataset.galleryBound === '1') return;
    slides.dataset.galleryBound = '1';

    const wrap = slides.closest('.adawat-product-card__media-wrap');
    const dots = wrap ? wrap.querySelectorAll('[data-card-dot]') : [];
    if (dots.length < 2) return;

    const sync = () => {
      const width = slides.clientWidth || 1;
      const index = Math.round(Math.abs(slides.scrollLeft) / width);
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    slides.addEventListener('scroll', sync, { passive: true });

    let startX = 0;
    let startY = 0;
    let axis = null;

    const releaseVertical = () => {
      slides.style.overflowX = '';
      axis = null;
    };

    slides.addEventListener(
      'touchstart',
      (event) => {
        const touch = event.touches[0];
        if (!touch) return;
        startX = touch.clientX;
        startY = touch.clientY;
        axis = null;
        slides.style.overflowX = '';
        event.stopPropagation();
      },
      { passive: true }
    );

    slides.addEventListener(
      'touchmove',
      (event) => {
        if (axis || !event.touches[0]) return;
        const dx = Math.abs(event.touches[0].clientX - startX);
        const dy = Math.abs(event.touches[0].clientY - startY);
        if (dx < 8 && dy < 8) return;
        axis = dx > dy ? 'x' : 'y';
        if (axis === 'y') slides.style.overflowX = 'hidden';
      },
      { passive: true }
    );

    slides.addEventListener('touchend', releaseVertical, { passive: true });
    slides.addEventListener('touchcancel', releaseVertical, { passive: true });

    slides.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') event.stopPropagation();
    });

    dots.forEach((dot) => {
      dot.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const index = Number(dot.getAttribute('data-card-dot') || 0);
        slides.scrollTo({ left: index * slides.clientWidth, behavior: 'smooth' });
      });
    });
  };

  const scan = () => {
    document.querySelectorAll('[data-card-slides]').forEach(bindGallery);
  };

  window.adawatBindCardGalleries = scan;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
